var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9987 2.66667C15.9987 1.19391 17.1926 0 18.6654 0H29.332C30.8048 0 31.9987 1.19391 31.9987 2.66667V5.33333H43.9987C45.4715 5.33333 46.6654 6.52724 46.6654 8C46.6654 9.47276 45.4715 10.6667 43.9987 10.6667H29.332H18.6654H3.9987C2.52594 10.6667 1.33203 9.47276 1.33203 8C1.33203 6.52724 2.52594 5.33333 3.9987 5.33333H15.9987V2.66667ZM11.9987 18.6667V40C11.9987 41.4728 13.1926 42.6667 14.6654 42.6667H33.332C34.8048 42.6667 35.9987 41.4728 35.9987 40V18.6667H11.9987ZM9.33203 13.3333C7.85927 13.3333 6.66536 14.5272 6.66536 16V40C6.66536 44.4183 10.2471 48 14.6654 48H33.332C37.7503 48 41.332 44.4183 41.332 40V16C41.332 14.5272 40.1381 13.3333 38.6654 13.3333H9.33203ZM17.332 22.6667C16.5957 22.6667 15.9987 23.2636 15.9987 24V37.3333C15.9987 38.0697 16.5957 38.6667 17.332 38.6667C18.0684 38.6667 18.6654 38.0697 18.6654 37.3333V24C18.6654 23.2636 18.0684 22.6667 17.332 22.6667ZM29.332 24C29.332 23.2636 29.929 22.6667 30.6654 22.6667C31.4017 22.6667 31.9987 23.2636 31.9987 24V37.3333C31.9987 38.0697 31.4017 38.6667 30.6654 38.6667C29.929 38.6667 29.332 38.0697 29.332 37.3333V24ZM23.9987 22.6667C23.2623 22.6667 22.6654 23.2636 22.6654 24V37.3333C22.6654 38.0697 23.2623 38.6667 23.9987 38.6667C24.7351 38.6667 25.332 38.0697 25.332 37.3333V24C25.332 23.2636 24.7351 22.6667 23.9987 22.6667Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.3b29f2c15c7202585df45deb94920cb2.svg";
export { ForwardRef as ReactComponent };